<!--
  bind-mobile 新用户 绑手机 设密码
  @see card-mobile-bind.vue
  下一步是去绑卡
-->

<template>
  <div style="height: 100%; background-color: #f7f8fa">
    <van-cell-group>
      <van-field v-model.trim="phone" label="手机号码" placeholder="请输入手机号码" @input="phoneInp" />

      <van-field v-model.trim="code" label="短信验证码" placeholder="请输入验证码">
        <van-button v-show="isVisibleCode" slot="button" round size="mini" type="info" @click="codeClick">发送验证码
        </van-button>
        <van-button v-show="!isVisibleCode" slot="button" disabled size="small" type="info">{{ disabledCodeText }}秒后重新获取
        </van-button>
      </van-field>

      <van-field :value="payPwd" clickable label="支付密码"
        placeholder="请输入6位数字密码" readonly type="password"
        @touchstart.native.stop=" payPwdShow = true; payPwdOkShow = false;" />

      <van-number-keyboard v-model="payPwd" :maxlength="6" :show="payPwdShow" @blur="payPwdShow = false" />

      <van-field :value="payPwdOk" clickable label="确认密码"
        placeholder="请输入6位数字密码" readonly type="password"
        @touchstart.native.stop=" payPwdOkShow = true; payPwdShow = false;" />
      <van-number-keyboard v-model="payPwdOk" :maxlength="6" :show="payPwdOkShow" @blur="payPwdOkShow = false" />
    </van-cell-group>

    <div style="margin: 16px">
      <van-button block class="login-btn" round type="info" @click="nextClick">下一步</van-button>
    </div>

    <div style="position: fixed; bottom: 40px;">
      <div style="text-align: center; width: 100vw; font-size: 14px;">
        <a href="/v4/Kefu">收不到短信验证码?</a>
      </div>
    </div>
  </div>
</template>

<script>
import { go_redirect_url } from '@/util/util'
import { XIZHANG_SEPARATOR } from "@/util/XiZhangUtil";
import { Dialog, Toast } from "vant";
import { send_validate_code_sms, validateSmsCode } from "@/api/user";
import preventBack from "@/mixins/prevent-back";

export default {
  name: "bind-mobile",

  mixins: [preventBack],

  data() {
    return {
      phone: "",
      code: "",
      cardPwd: "",
      payPwd: "",
      payPwdShow: false,
      payPwdOk: "",
      payPwdOkShow: false,
      payPwd2: "",
      isVisibleCode: true,
      disabledCodeText: "",
      time: 120,
    };
  },

  methods: {
    phoneInp() {
      if (this.phone.length > 11) {
        this.phone = this.phone.substring(0, 11);
      }
    },

    // 点击发送验证码
    codeClick() {
      if (this.checkPhone()) {
        this.isVisibleCode = false;
        this.getTime();
        send_validate_code_sms(this.phone).then((res) => { });
      }
    },

    nextClick() {
      if (this.checkPhone()) {
        if (this.code === "") {
          Toast({ message: "验证码不能为空", duration: 1000 });
          return;
        }

        if (this.payPwd === "") {
          Toast({ message: "密码不能为空", duration: 1000 });
          return;
        }

        if (this.payPwd !== this.payPwdOk) {
          Toast({ message: "两次输入密码不一致", duration: 1000 });
          return;
        }

        validateSmsCode(this.phone, this.code, this.payPwd).then((res) => {
          if (res.code === 0) {
            this.$store.dispatch("store_get_user_info").then(res => {
              budo_log.info("#121 go bind card, res=", res)

              // 是西藏 不绑卡
              if (res && res.openid && res.openid.indexOf(XIZHANG_SEPARATOR) > -1) {
                go_redirect_url()
              } else {
                Dialog.confirm({ message: "去绑卡页面?" }).then(() => {
                  location.href = `${window.location.origin}/web/bind-card`
                })
              }
            });
          } else {
            Dialog({ title: "绑定失败", message: res.msg });
          }
        });
      }
    },

    // 倒计时
    getTime() {
      this.time--;
      this.disabledCodeText = this.time;
      if (this.time === 0) {
        this.isVisibleCode = true;
        this.time = 120;
        return;
      }

      setTimeout(() => {
        this.getTime();
      }, 1000);
    },

    // 手机号验证
    checkPhone() {
      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        Toast({ message: "请输入正确的手机号", duration: 1000 });
        return false;
      }
      return true;
    },
  },
};
</script>